import { IfpApplicationAction } from '@shared/sec-loans'
import { useReducer } from 'react'
import { AnyActorRef } from 'xstate'

import SendStep from '../send-step/SendStep'
import { SignStep } from '../sign-step/SignStep'

export interface SignAndSendStepProps {
  parentService: AnyActorRef
  onAbort: () => unknown
  applicationId: string
  actionType: IfpApplicationAction
}

export const SignAndSendStep = ({ applicationId, actionType, parentService, onAbort }: SignAndSendStepProps) => {
  const [signAndSendState, dispatch] = useReducer(signAndSendReducer, {
    value: 'SIGNING',
  })

  const handleOnSigned = (code: string) => dispatch({ type: 'SIGNED', authCode: code })
  const handleSigningError = () => parentService.send({ type: 'SEND_FAILED' })
  const handleSigningCancel = () => parentService.send({ type: 'SEND_CANCELED' })

  if (signAndSendState.value === 'SIGNING') {
    return (
      <SignStep
        onSigned={handleOnSigned}
        onError={handleSigningError}
        onCancel={handleSigningCancel}
        applicationId={applicationId}
      />
    )
  }

  if (signAndSendState.value === 'SENDING') {
    return (
      <SendStep
        authCode={signAndSendState.authCode}
        applicationId={applicationId}
        actionType={actionType}
        parentService={parentService}
        onAbort={onAbort}
      />
    )
  }

  return undefined
}

type SignAndSendStepState = { value: 'SIGNING' } | { value: 'SENDING'; authCode: string }
type SignAndSendAction = { type: 'SIGNED'; authCode: string }

const signAndSendReducer = (state: SignAndSendStepState, action: SignAndSendAction): SignAndSendStepState => {
  switch (action.type) {
    case 'SIGNED':
      return { value: 'SENDING', authCode: action.authCode }
    default:
      return state
  }
}
